import React, { FC, useCallback } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Row, Typography } from 'components';
import { ADMIN_ROUTES } from 'constants/routes';
import { useNavigate } from 'react-router-dom';

interface IRolesDrawer {
  onExpand: () => void;
  drawerState: boolean;
  data?: Record<string, any>[];
}

export const RolesDrawer: FC<IRolesDrawer> = React.memo((props) => {
  const { onExpand, drawerState, data } = props;
  const navigate = useNavigate();
  const onRedirectToRole = useCallback(
    (value: string) => {
      navigate(`${ADMIN_ROUTES.role.view}/${value}/${ADMIN_ROUTES.role.permissions}`);
    },
    [navigate]
  );
  return (
    <Drawer
      closeIcon={null}
      placement="left"
      width={471}
      open={drawerState}
      onClose={() => onExpand()}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      title={'Roles'}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={() => onExpand()} type="text" />
      </div>
      <Row gutter={[0, 12]}>
        {data?.map((role) => (
          <Col key={role.id} span={24}>
            <Row align={'middle'} className={'gap-10'} wrap={false}>
              <Typography.Text
                underline
                className={'font-weight-600'}
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => onRedirectToRole(role.id)}
              >
                {role.name}
              </Typography.Text>
            </Row>
          </Col>
        ))}
      </Row>
    </Drawer>
  );
});
